import { z } from 'zod';

import { baseNotificationRawSchema, baseNotificationRawSchemaParser } from './BaseNotification';

export const fixationPeriodNotificationType = z.literal('LEAD_EXP');

export const fixationPeriodNotificationSchema = baseNotificationRawSchema
  .extend({
    type: fixationPeriodNotificationType,
    extra: z.object({
      lead_id: z.number(),
    }),
  })
  .transform((raw) => {
    return {
      ...baseNotificationRawSchemaParser(raw),
      type: raw.type,
      extra: {
        leadId: raw.extra.lead_id,
      },
    };
  });

export type FixationPeriodNotificationEntityApi = z.input<typeof fixationPeriodNotificationSchema>;

export type FixationPeriodNotificationEntity = z.infer<typeof fixationPeriodNotificationSchema>;
